module.exports = __webpack_public_path__ + "static/media/key.d5b4c54a.svg";